"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.http = exports.HTTPClient = void 0;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SUCCESS_CODE = 0;

var HTTPClient = /*#__PURE__*/function () {
  function HTTPClient() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var successCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SUCCESS_CODE;

    _classCallCheck(this, HTTPClient);

    this.successCode = successCode;

    _defineProperty(this, "instance", void 0);

    var defaultConfig = {
      baseURL: "/api"
    };
    this.instance = _axios["default"].create(_objectSpread(_objectSpread({}, defaultConfig), config));
    this.setupCommonInterceptors();
  }

  _createClass(HTTPClient, [{
    key: "setupCommonInterceptors",
    value: function setupCommonInterceptors() {
      var _this = this;

      // 请求劫持
      this.instance.interceptors.request.use(function (config) {
        return new Promise(function (resolve, reject) {
          var requestConfig = _objectSpread({}, config); // 向所有的请求中加入 token 参数


          if (!Session) {
            return resolve(requestConfig);
          }

          Session.getToken(function (token) {
            var tokenStr = '';

            if (typeof token === 'string') {
              tokenStr = token;
            } else {
              tokenStr = token.token;
            }

            resolve(_objectSpread(_objectSpread({}, requestConfig), {}, {
              params: _objectSpread(_objectSpread({}, config.params), {}, {
                token: tokenStr
              })
            }));
          }, reject);
        });
      }); // 响应劫持

      this.instance.interceptors.response.use(function (response) {
        var data = response.data,
            headers = response.headers;

        if (data.code !== _this.successCode) {
          return Promise.reject(response);
        }

        var date = headers.date;

        if (isNaN(new Date(date).getTime())) {
          return _objectSpread(_objectSpread({}, response.data), {}, {
            server_date: new Date()
          });
        }

        return _objectSpread(_objectSpread({}, response.data), {}, {
          server_date: new Date(date)
        });
      });
    }
  }, {
    key: "request",
    value: function request(config) {
      return this.instance.request(config);
    }
  }, {
    key: "get",
    value: function get(url, config) {
      return this.instance.get(url, config);
    }
  }, {
    key: "head",
    value: function head(url, config) {
      return this.instance.get(url, config);
    }
  }, {
    key: "delete",
    value: function _delete(url, config) {
      return this.instance["delete"](url, config);
    }
  }, {
    key: "post",
    value: function post(url, data, config) {
      return this.instance.post(url, data, config);
    }
  }, {
    key: "put",
    value: function put(url, data, config) {
      return this.instance.put(url, data, config);
    }
  }, {
    key: "patch",
    value: function patch(url, data, config) {
      return this.instance.patch(url, data, config);
    }
  }]);

  return HTTPClient;
}();

exports.HTTPClient = HTTPClient;
var http = new HTTPClient();
exports.http = http;


//////////////////
// WEBPACK FOOTER
// ./~/@weike/toolkit/lib/http/index.js
// module id = 586
// module chunks = 6